import React from 'react';
import MonthlyViewItem from './MonthlyViewItem';
import { eachDayOfInterval, endOfMonth, format, startOfMonth } from 'date-fns-jalali';

const MonthlyView = ({ meetings, currentDate, onItemClick }) => {
  const daysOfWeek = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه'];
  const monthStart = startOfMonth(currentDate);
  const monthEnd = endOfMonth(currentDate);
  const days = eachDayOfInterval({ start: monthStart, end: monthEnd });
  const firstDayOffset = (monthStart.getDay() + 1) % 7;
  const leadingDays = Array.from({ length: firstDayOffset }, (_, index) => `empty-${index}`);
  const monthTitle = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
    month: 'long',
    year: 'numeric'
  }).format(currentDate);

  return (
    <div className="bg-white rounded-3xl shadow-sm border border-slate-100 p-6">
      {/* هدر روزهای هفته */}
      <h2 className="text-center text-lg font-bold text-slate-800 mb-4">{monthTitle}</h2>
      <div className="grid grid-cols-7 gap-2 mb-4">
        {daysOfWeek.map((day) => (
          <div key={day} className="text-center text-sm font-bold text-slate-400 py-2">
            {day}
          </div>
        ))}
      </div>

      {/* تقویم ماهانه */}
      <div className="grid grid-cols-7 gap-2">
        {leadingDays.map((day) => <div key={day} className="min-h-32" />)}
        {days.map((day) => {
          const dayNumber = Number(format(day, 'd'));
          const dayMeetings = meetings.filter((m) => m.day === dayNumber);
          
          return (
            <div key={day.toISOString()} className="min-h-32 min-w-0 border border-slate-100 rounded-xl p-2 bg-slate-50/30 flex flex-col gap-2 transition-all hover:bg-slate-50">
              <span className="text-xs font-bold text-slate-400">{format(day, 'd')}</span>
              
              <div className="grid grid-cols-[repeat(auto-fill,minmax(2.25rem,1fr))] gap-1.5 items-start">
                {dayMeetings.map((meeting) => (
                  <MonthlyViewItem key={meeting.id} meeting={meeting} onClick={() => onItemClick && onItemClick(meeting)} />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MonthlyView;